import { cx } from './cx';
import styles from './Divider.module.css';

/** Purely visual separator (hidden from assistive technology). */
export function Divider({ orientation = 'vertical' }: { orientation?: 'vertical' | 'horizontal' }) {
  return <span aria-hidden="true" className={cx(styles.divider, styles[orientation])} />;
}
